import { Hms } from "components/StatisticsDataTable/Dto/DataTableStatisticDto";
import { convertTimeToMiuntes } from "../Utils";

export const buildMinutesPredicate = (pattern: string | undefined) => {
  if (!pattern) return null;

  const trimmed = pattern.replace(/\s+/g, '');
  const m = trimmed.match(/^([<>])(\d+(?:\.\d+)?)$/);
  if (!m) return null;

  const op = m[1] as '>' | '<';
  const n = Number(m[2]);

  return (value: Hms | null | undefined) => {
    if (value == null) return false;

    const convertedValue = convertTimeToMiuntes(value);
    return op === '>' ? convertedValue > n : convertedValue < n;
  };
};